/**
 * Alexandre Mareuil — Bascule automatique de coloris.
 *
 * Sur les fiches produit (thème Horizon), quand un client change la matière ou la
 * taille, le coloris précédemment sélectionné peut ne plus exister dans la nouvelle
 * combinaison. Le thème re-render alors le variant-picker côté serveur, le coloris
 * obsolète reste coché (anneau « sélectionné ») tout en étant barré, et le bouton
 * passe à « Indisponible » (script[data-variant] === "null").
 *
 * Ce script écoute les événements déjà émis par le thème et, dans ce seul cas,
 * sélectionne automatiquement la première valeur disponible de l'option fautive —
 * en préservant l'option que le client vient de changer. La sélection reste ainsi
 * toujours valide et achetable.
 *
 * Aucune dépendance. N'édite pas le bundle compilé theme.js.
 */
(function () {
  'use strict';

  // Dernière option changée par le client, par formulaire : { [formId]: position }.
  var anchorByForm = Object.create(null);
  // Garde anti-boucle : nombre de bascules automatiques enchaînées, par formulaire.
  var snapCountByForm = Object.create(null);

  function isOptionInput(el) {
    return el && el.matches && el.matches('input[data-option-position]');
  }

  function labelFor(input) {
    if (!input || !input.id) return null;
    return document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]');
  }

  function isUnavailable(input) {
    if (input.disabled) return true;
    var label = labelFor(input);
    return !!(label && label.classList.contains('is-disabled'));
  }

  // Mémorise l'option changée uniquement pour une vraie interaction utilisateur.
  // Les changements qu'on déclenche nous-mêmes ont isTrusted === false.
  document.addEventListener(
    'change',
    function (event) {
      if (!event.isTrusted) return;
      var target = event.target;
      if (!isOptionInput(target)) return;
      var formId = target.getAttribute('form');
      if (!formId) return;
      anchorByForm[formId] = target.getAttribute('data-option-position');
      snapCountByForm[formId] = 0;
    },
    true
  );

  function autoSnap(formId) {
    if (!formId) return;

    var picker = document.querySelector('variant-picker[form-id="' + formId + '"]');
    if (!picker) return;

    // Déclencheur conservateur : n'agir que pour une combinaison inexistante.
    // (Une variante en rupture existe encore -> data-variant non nul -> on n'y touche pas.)
    var variantScript = picker.querySelector('script[data-variant]');
    if (!variantScript || variantScript.textContent.trim() !== 'null') return;

    var anchor = anchorByForm[formId];
    if (anchor == null) return; // pas d'interaction utilisateur mémorisée

    var inputs = Array.prototype.slice.call(
      document.querySelectorAll('input[data-option-position][form="' + formId + '"]')
    );
    if (!inputs.length) return;

    // Regroupe les inputs par position d'option.
    var groups = Object.create(null);
    var positions = [];
    inputs.forEach(function (input) {
      var pos = input.getAttribute('data-option-position');
      if (!groups[pos]) {
        groups[pos] = [];
        positions.push(pos);
      }
      groups[pos].push(input);
    });

    // Garde anti-boucle.
    snapCountByForm[formId] = (snapCountByForm[formId] || 0) + 1;
    if (snapCountByForm[formId] > positions.length + 1) return;

    // Corrige une option fautive par cycle (le re-render relancera autoSnap si besoin).
    for (var i = 0; i < positions.length; i++) {
      var pos = positions[i];
      if (pos === anchor) continue; // ne jamais toucher l'option choisie par le client

      var group = groups[pos];
      var checked = group.filter(function (input) {
        return input.checked;
      })[0];
      if (!checked || !isUnavailable(checked)) continue; // cette option est déjà valide

      var replacement = group.filter(function (input) {
        return !isUnavailable(input);
      })[0];
      if (!replacement) continue; // aucune valeur disponible -> laisser « Indisponible »

      replacement.checked = true;
      replacement.dispatchEvent(new Event('change', { bubbles: true }));
      return; // une seule bascule ; on laisse le re-render suivant faire le reste
    }
  }

  function onRerender() {
    // Les événements du thème sont émis sur le <form>, mais `form.id` est masqué par
    // le champ caché <input name="id">. On passe donc par les <variant-picker> présents
    // (leur attribut form-id est la chaîne fiable, et couvre picker principal / sticky /
    // quick-buy). autoSnap est idempotent et ne fait rien hors du cas ciblé.
    var pickers = document.querySelectorAll('variant-picker[form-id]');
    for (var i = 0; i < pickers.length; i++) {
      autoSnap(pickers[i].getAttribute('form-id'));
    }
  }

  // Capture pour attraper les événements même s'ils ne bubblent pas jusqu'au document.
  document.addEventListener('variant:change', onRerender, true);
  document.addEventListener('product:rerender', onRerender, true);
})();
